import { render, staticRenderFns } from "./scroll-nav-bar.vue?vue&type=template&id=64a7f574&scoped=true&"
import script from "./scroll-nav-bar.vue?vue&type=script&lang=js&"
export * from "./scroll-nav-bar.vue?vue&type=script&lang=js&"
import style0 from "./scroll-nav-bar.vue?vue&type=style&index=0&id=64a7f574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7f574",
  null
  
)

export default component.exports